import ProjectListView from './ProjectListView';
import './ProjectListView.scss';

export default ProjectListView;
